<section class="wallet-panel">
  <div class="panel-heading">
    <div>
      <p class="eyebrow typo-label-2">Wallet auth</p>
      <h2 class="typo-title-2-bolder">KCC20 session</h2>
    </div>
    <kc-button
      [class]="
        statusTagClass(session() ? TagStatus.SUCCESS : TagStatus.NEUTRAL)
      "
      variant="tag"
      size="s"
      [text]="session() ? 'Connected' : 'Disconnected'"
      [isSelected]="
        statusTagSelected(session() ? TagStatus.SUCCESS : TagStatus.NEUTRAL)
      "
      [isDisabled]="true"
    />
  </div>

  @if (session()) {
    <div class="session-card card-2">
      <kc-wallet-avatar [address]="session()!.walletAddress" size="md" />
      <div class="session-meta">
        <p class="typo-paragraph-2-bold">
          {{ walletLabels[session()!.walletType] }}
        </p>
        <div class="session-address">
          <strong class="typo-paragraph-1">{{
            session()!.walletAddress | truncateWalletAddress
          }}</strong>
          <kc-icon-button
            variant="secondary"
            size="xs"
            icon="copy"
            aria-label="Copy wallet address"
            title="Copy wallet address"
            (buttonClick)="copyWalletAddress(session()!.walletAddress)"
          />
        </div>
        <small class="typo-label-2"
          >Owner {{ session()!.kcc20Owner | truncateWalletAddress }}</small
        >
      </div>
    </div>
    <kc-button
      variant="secondary"
      size="m"
      [isFullWidth]="true"
      text="Disconnect"
      (buttonClick)="disconnect()"
    />
  } @else {
    <div class="wallet-list">
      @for (wallet of wallets(); track wallet.type) {
        <button
          type="button"
          class="wallet-option card-2"
          [disabled]="!wallet.installed || connecting()"
          (click)="connect(wallet.type)"
        >
          <img
            [src]="wallet.logo"
            [alt]="wallet.label + ' logo'"
            width="32"
            height="32"
            loading="eager"
            decoding="async"
            fetchpriority="high"
          />
          <span>
            <strong class="typo-paragraph-2-bold">{{ wallet.label }}</strong>
            <small class="typo-label-2">{{
              wallet.installed ? 'Ready' : 'Not detected'
            }}</small>
          </span>
          @if (connectingWalletType() === wallet.type) {
            <em class="typo-label-2">Connecting</em>
          }
        </button>
      }
    </div>
  }

  @if (networkPrompt()) {
    <kc-alert variant="warning" [text]="networkPrompt()!.message" />
  }
</section>
